"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NullFromEmptyGeoPosition = exports.isEmptyGeoPosition = exports.EmptyGeoPosition = exports.NonEmptyGeoPosition = exports.isEqualGeoPosition = exports.GeoPosition = exports.Longitude = exports.Latitude = exports.makeNullAddress = exports.Address = exports.CountryCodeIso3166Alpha3 = exports.CountryCodeIso3166Alpha2 = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const IsoCountries = __importStar(require("i18n-iso-countries"));
exports.NAMESPACE = 'Geography';
exports.CountryCodeIso3166Alpha2 = effect_1.Schema.Literal(...effect_1.Record.keys(IsoCountries.getAlpha2Codes())).annotations({
    identifier: `${exports.NAMESPACE}.CountryCodeIso3166Alpha2`,
    description: 'ISO 3166-1 alpha-2 country code',
    documentation: 'https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2',
});
exports.CountryCodeIso3166Alpha3 = effect_1.Schema.Literal(...effect_1.Record.keys(IsoCountries.getAlpha3Codes())).annotations({
    identifier: `${exports.NAMESPACE}.CountryCodeIso3166Alpha3`,
    description: 'ISO 3166-1 alpha-3 country code',
    documentation: 'https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3',
});
exports.Address = effect_1.Schema.Struct({
    address: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'The street address',
    }),
    zip: effect_1.Schema.NullOr(effect_1.Schema.String),
    city: effect_1.Schema.NullOr(effect_1.Schema.String),
    state: effect_1.Schema.propertySignature(effect_1.Schema.NullOr(effect_1.Schema.String)).annotations({
        description: 'State, province, or region',
    }),
    country: effect_1.Schema.NullOr(effect_1.Schema.String),
    countryCode: effect_1.Schema.NullOr(exports.CountryCodeIso3166Alpha3),
    addressExtra: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(effect_1.Schema.String), {
        exact: true,
        default: () => null,
    }).annotations({
        description: 'Additional address information (apartment, suite, etc.)',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Address`,
    description: 'A physical address',
});
const makeNullAddress = () => effect_1.Record.map(exports.Address.fields, () => null);
exports.makeNullAddress = makeNullAddress;
exports.Latitude = effect_1.Schema.Number.pipe(effect_1.Schema.between(-90, 90)).annotations({
    identifier: `${exports.NAMESPACE}.Latitude`,
    examples: [45.485506],
});
exports.Longitude = effect_1.Schema.Number.pipe(effect_1.Schema.between(-180, 180)).annotations({
    identifier: `${exports.NAMESPACE}.Longitude`,
    examples: [9.208889],
});
exports.GeoPosition = effect_1.Schema.Struct({
    lat: exports.Latitude,
    lon: exports.Longitude,
}).annotations({
    identifier: `${exports.NAMESPACE}.GeoPosition`,
    description: 'A combination of both latitude and longitude, representing a location on Earth',
    documentation: 'https://en.wikipedia.org/wiki/Geographic_coordinate_system',
    examples: [{ lat: 45.485506, lon: 9.208889 }],
    equivalence: () => (self, that) => self.lat === that.lat && self.lon === that.lon,
    pretty: () => ({ lat, lon }) => `(${lat.toFixed(6)}, ${lon.toFixed(6)})`,
});
/**
 * See {@link GeoPosition}
 */
exports.isEqualGeoPosition = effect_1.Schema.equivalence(exports.GeoPosition);
/**
 * See {@link GeoPosition}
 */
exports.NonEmptyGeoPosition = exports.GeoPosition.pipe(effect_1.Schema.filter(({ lat, lon }) => lat !== 0 || lon !== 0)).annotations({
    identifier: `${exports.NAMESPACE}.NonEmptyGeoPosition`,
    description: 'Is used to identify a non-empty `GeoPosition` - ' +
        'a `GeoPosition` where either latitude or longitude are not `0`',
    examples: [{ lat: 45.485506, lon: 9.208889 }],
});
/**
 * See {@link GeoPosition}
 */
exports.EmptyGeoPosition = effect_1.Schema.Struct({
    lat: effect_1.Schema.tag(0),
    lon: effect_1.Schema.tag(0),
}).annotations({
    identifier: `${exports.NAMESPACE}.EmptyGeoPosition`,
    description: 'A `GeoPosition` where both latitude and longitude are `0`',
    examples: [{ lat: 0, lon: 0 }],
});
/**
 * See {@link EmptyGeoPosition}
 */
exports.isEmptyGeoPosition = effect_1.Schema.is(exports.EmptyGeoPosition);
/**
 * See {@link EmptyGeoPosition}
 */
exports.NullFromEmptyGeoPosition = effect_1.Schema.transform(exports.EmptyGeoPosition, effect_1.Schema.Null, {
    strict: true,
    encode: () => exports.EmptyGeoPosition.make(),
    decode: () => null,
}).annotations({
    identifier: `${exports.NAMESPACE}.NullFromEmptyGeoPosition`,
    description: 'Is used to decode `EmptyGeoPosition` into `null`',
});
//# sourceMappingURL=geography.js.map